/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_1_P1Inputs */

const en_privacy_section_1_p1 = /** @type {(inputs: Privacy_Section_1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The controller of your personal data is Nauris Linde, a self-employed sole trader (saimnieciskās darbības veicējs) registered in the Taxpayer Register of the Latvian State Revenue Service (VID) and trading under the name “Lindevo”. Lindevo is a trading name — not a registered company or a separate legal entity. Taxpayer registration code, second part: 11905. Address: Liepāja, Latvia. Email: info@lindevo.com.`)
};

const lv_privacy_section_1_p1 = /** @type {(inputs: Privacy_Section_1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu personas datu apstrādes pārzinis ir Nauris Linde, saimnieciskās darbības veicējs, kas reģistrēts Valsts ieņēmumu dienesta Nodokļu maksātāju reģistrā un darbojas ar zīmolu „Lindevo”. Lindevo ir zīmolvārds — nevis reģistrēts uzņēmums vai atsevišķa juridiska persona. Nodokļu maksātāja reģistrācijas koda otrā daļa: 11905. Adrese: Liepāja, Latvija. E-pasts: info@lindevo.com.`)
};

/**
* | output |
* | --- |
* | "The controller of your personal data is Nauris Linde, a self-employed sole trader (saimnieciskās darbības veicējs) registered in the Taxpayer Register of the..." |
*
* @param {Privacy_Section_1_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_1_p1 = /** @type {((inputs?: Privacy_Section_1_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_1_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_1_p1(inputs)
	return en_privacy_section_1_p1(inputs)
});